/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DbrEventResponse } from '../../models/dbr-event-response';

export interface EventsControllerFindOneByIdOrName$Params {
  id: string;
}

export function eventsControllerFindOneByIdOrName(http: HttpClient, rootUrl: string, params: EventsControllerFindOneByIdOrName$Params, context?: HttpContext): Observable<StrictHttpResponse<DbrEventResponse>> {
  const rb = new RequestBuilder(rootUrl, eventsControllerFindOneByIdOrName.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DbrEventResponse>;
    })
  );
}

eventsControllerFindOneByIdOrName.PATH = '/events/id-or-name/{id}';
